module.exports = __webpack_public_path__ + "img/team.b28d2caf.png";